import React from 'react';
import { MobilityIndex, InvestmentIndex, QualityIndex } from './rankingCards';
import { RankingItemComponent } from './RankingItemComponent';

const extractFields =
	(positionName = 'global_passport_rank') =>
	(props) => {
		return {
			countryCode: props?.iso2c || 'es',
			position: props?.[positionName] || '0',
		};
	};

export const RankingSection = (props) => {
	const { quality, mobility, investment } = props;
	const items = [
		{
			...MobilityIndex,
			title: 'Best Passports for Mobility',
			countries: mobility.map(extractFields('mobility_rank')),
		},
		{
			...InvestmentIndex,
			title: 'Best Passports for Investment',
			countries: investment.map(extractFields('invest_rank')),
		},
		{
			...QualityIndex,
			title: 'Best Passports for Quality of Life',
			countries: quality.map(extractFields('eqol_rank')),
		},
	];

	return (
		<div className="rankings">
			<div className="container section-wrapper">
				<h2 className="section-title">
					Top Passports for Mobility, Investment, and Quality of Life
				</h2>
				<div className="section-content rankings__wrapper">
					{items.map(RankingItemComponent)}
				</div>
			</div>
		</div>
	);
};
